import React from 'react';

const PhraseList = ({
  phrases,
  paginatedPhrases,
  onDeletePhrase,
  onShowEnlarged,
  splitPhrase,
  currentPage,
  phrasesPerPage,
  paginate,
}) => {
  const totalPages = Math.ceil(phrases.length / phrasesPerPage);

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {paginatedPhrases.map((phrase, index) => {
          const { english, vietnamese } = splitPhrase(phrase);
          const phraseId = phrase.id || phrase.phraseId || index;

          return (
            <div
              key={phraseId}
              className="relative group p-5 rounded-xl shadow-md transition-all duration-300 bg-white border border-gray-200 hover:bg-gray-50"
            >
              <div onClick={() => onShowEnlarged(phrase)} className="cursor-pointer">
                <p className="text-3xl font-semibold text-gray-800 mb-2">
                  {english || 'Không có tiếng Anh'}
                </p>
                {vietnamese && (
                  <p className="text-2xl text-gray-600">
                    {vietnamese}
                  </p>
                )}
              </div>
              <button
                onClick={() => onDeletePhrase(phraseId)}
                className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                aria-label="Xóa cụm từ"
              >
                &times;
              </button>
            </div>
          );
        })}
      </div>

      {totalPages > 1 && (
        <nav className="flex justify-center items-center space-x-2">
          <button
            onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 rounded-md ${
              currentPage === 1
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            } transition-colors`}
          >
            Trước
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
            <button
              key={number}
              onClick={() => paginate(number)}
              className={`px-3 py-1 rounded-md ${
                currentPage === number
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              } transition-colors`}
            >
              {number}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage < totalPages ? currentPage + 1 : totalPages)}
            disabled={currentPage === totalPages}
            className={`px-3 py-1 rounded-md ${
              currentPage === totalPages
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            } transition-colors`}
          >
            Sau
          </button>
        </nav>
      )}
    </div>
  );
};

export default PhraseList;
